import {
  IconBell,
  IconBinocularsGray,
  IconChainLink,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconZoneGray,
} from '@assets/images/icon';
import { rtlsSystem } from '@assets/images/solution';
import mainVideo from '@src/assets/images/solution/constructionSafety/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/logisticsManage/img/1.avif';
import image2 from '@src/assets/images/solution/logisticsManage/img/2.avif';
import image3 from '@src/assets/images/solution/logisticsManage/img/3.avif';
import image4 from '@src/assets/images/solution/logisticsManage/img/4.avif';
import image5 from '@src/assets/images/solution/logisticsManage/img/5.avif';
import image6 from '@src/assets/images/solution/logisticsManage/img/6.avif';

export default {
  type: '建設ソリューション',

  banner: {
    title: '複雑な屋内物流倉庫でのコンテナ車両位置を自動追跡',
    desc: '広い物流倉庫内でコンテナ車両の位置をリアルタイムで把握し、空いているエリアを即座に確認できます。',
  },

  video: {
    title: '複雑な倉庫でも車両は目的地へ一直線',
    desc: 'コンテナ車両に取り付けたRTLSタグと屋内位置測位インフラが連携し、位置を自動で識別します。ダッシュボードには駐車位置と車両の動きがリアルタイムで表示され、作業者は迷わず作業に入れます。',
    play: mainVideo,
  },

  func: [
    {
      theme: '車両追跡および位置データ収集',
      title: 'コンテナ車両位置の自動識別',
      desc: '車両に取り付けられたRTLSタグにより、コンテナの位置がリアルタイムで自動識別され、座標はダッシュボードで視覚化されるため、現在位置と状態を正確に把握できます。',
      sub1: '高精度の提供',
      icon1: IconRulerGray,
      sub2: 'リアルタイム状況把握',
      icon2: IconClockGray,
      image: image1,
    },
    {
      title: '駐車可能エリアのリアルタイム表示',
      desc: 'システムが現在空いている駐車スペースを自動で解析し、ドライバーに視覚的に案内します。車両は案内された最適位置に直行でき、駐車待ち時間を短縮できます。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '迅速なデータ連携',
      icon2: IconTvocGray,
      image: image2,
    },
    {
      title: '経路重複防止のための動線視覚化',
      desc: '複数車両が同時に移動する際、経路衝突が発生しないよう予想動線が画面に視覚化されます。これにより作業の混雑を事前に防ぎ、進入および回転経路を整理できます。',
      sub1: 'リアルタイム位置追跡',
      icon1: IconBinocularsGray,
      sub2: '高精度の提供',
      icon2: IconRulerGray,
      image: image3,
    },
    {
      theme: '運用管理の自動化と証拠活用',
      title: 'コンテナ位置検索機能',
      desc: '作業者はコンテナ番号または車両番号を検索窓に入力することで、該当車両の現在位置を即座に確認できます。手動探索なしで目的の車両に素早くアクセスでき、作業効率が向上します。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image4,
    },
    {
      title: '入出庫記録および位置履歴管理',
      desc: '各車両の入場時点から最終位置までの移動履歴をタイムラインで保存します。この情報は後の物流フロー分析や入出庫の証拠資料として活用されます。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image5,
    },
    {
      title: 'リアルタイムアラートおよび管理者ダッシュボード構成',
      desc: '異常経路、長時間待機、指定エリア外駐車など異常兆候が発生した場合、リアルタイムで管理者に通知され、ダッシュボードで全体状況を統合監視できます。',
      sub1: '自由な範囲設定',
      icon1: IconZoneGray,
      sub2: '複数エリア設定',
      icon2: IconTagGray,
      image: image6,
    },
  ],

  subfunc: {
    title: '多様な機能',
    desc: '作業者の安全を確保することは効率性を高め、事故による損失を削減します。ORBROは建設現場の作業者の安全を守るため、最適な機能を備えています。作業者が危険区域に近づいたり事故が発生した場合、または重機が潜在的な危険を引き起こす可能性がある場合にも適切に対応できるシステムを構築しています。',
    data: [
      { icon: IconBinocularsGray, title: 'コンテナ位置追跡', desc: 'タグで位置を自動追跡・可視化。' },
      { icon: IconClockGray, title: '屋外ドック車両把握', desc: 'AI分析で台数と位置を即表示。' },
      { icon: IconChartBarGray, title: '駐車区画自動分析', desc: '空き区画をリアルタイム提案。' },
      { icon: IconSearch, title: '番号検索機能', desc: '番号入力で位置を即確認。' },
      { icon: IconZoneGray, title: '室内地図位置確認', desc: '室内地図で車両位置を表示。' },
      { icon: IconDashboard, title: 'リアルタイム状況板', desc: '車両位置と状態を一目で。' },
      { icon: IconRoute, title: '動線可視化', desc: '経路衝突防止・混雑緩和。' },
      { icon: IconClockGray, title: '入出庫時間保存', desc: '出入り履歴を自動保存。' },
      { icon: IconChartRadius, title: '在庫フロー報告', desc: '位置履歴で自動レポート。' },
      { icon: IconUserCheck, title: '位置作業効率化', desc: '即座に見つけて作業効率UP。' },
    ],
  },

  system: {
    title: 'システム構成',
    img: rtlsSystem,
  },

  productTitle: '製品構成',
  product: [{ tag: 'workerPackage' }, { tag: 'assetPackage' }],

  contents: [{ data: 'constructionAsset' }, { data: 'constructionEquipment' }, { data: 'blogRTLS' }, { data: 'blogMedical' }],
};
